import Cookie from 'js-cookie'

/**
 * fetch함수에 API호출 시 공용으로 사용하는 설정을 추가한 함수
 *
 * @param {RequestInfo} input fetch input
 * @param {RequestInit} init fetch init
 * @param {Boolean} json fetch init
 */
export default function fetchApi(input, init = {}, json = true) {
  var options = {
    ...init,
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      ...init.headers,
      'X-XSRF-TOKEN': Cookie.get('XSRF-TOKEN'),
    }
  }

  return fetch(input, {
    ...init,
    method: 'POST',
    headers: {
      ...init.headers,
      'X-XSRF-TOKEN': Cookie.get('XSRF-TOKEN'),
    },
  }).then((res) => {
    if (res.ok) {
      return res.text()
    }

    if (res.status === 400 || res.status === 401) {
      return res.json().then((errorMessage) => {
        throw errorMessage.msg
      })
    }

    if (res.status === 403) {
      throw Error('[MGX403-003] 요청하신 페이지를 조회할 수 있는 권한이 없습니다.')
    }

    if (res.status === 500) {
      throw Error('[MGX500-002] 관리자에게 문의하세요.')
    }

    if (res.status === 404 || res.status === 405) {
      throw Error('[MGX403-004] 요청하신 페이지를 찾을 수 없습니다.')
    }

    if (res.status === 901 || !Cookie.get('JSESSIONID')) {
      Cookie.remove('XSRF-TOKEN')
      setImmediate(() => {
        alert('세션이 종료되었습니다')
      })
    }
  }).then((text) => {
    return text.length === 0 ? {} : JSON.parse(text);
  })
}
